<template>
  <div id="container">
    <div class="item-box-content" style="padding-bottom:0px;">
      <div class="title-font-style">
        <span>收款信息</span>
      </div>
      <el-form :model="bankformList" class="details-line-height" style="padding:20px 30px 0 30px">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="收款编号：">{{ bankformList.receiptNumber }}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="收款方式：">
              {{ bankformList.receiptClass}}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="收款类型：">{{bankformList.receiptType}}</el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="状态：">{{states(bankformList.state)}}

            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="票据金额：">{{bankformList.billMoney | billMoney}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="客户名称：">
              <span style="color:#276CFF" v-cust @click="goCustomerDetail(bankformList.cusId)">{{bankformList.cusName}}</span>
              </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="备注：">{{bankformList.mark}}</el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="item-box-content" style="padding:0 20px 10px">

      <el-form class="details-line-height" style="padding:20px 30px 0 30px" :model="bankformList">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="承兑汇票：">{{bankformList.billNumber}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="出票单位：">{{bankformList.billCompany}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="出票行:">{{bankformList.billBank}}</el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="出票日期：">{{ formatData(bankformList.billDate) | dateFilterD}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="到期日期：">{{ formatData(bankformList.billEnddate) | dateFilterD}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="付款凭证:" v-if="bankformList.attachments && bankformList.attachments.length !== 0">
              <div class="down">
                <el-button style="margin-left: 10px;" type="text" @click="onSee(bankformList.attachments)">查看</el-button>
                <el-button type="text" @click="downloadFile(bankformList.attachments && bankformList.attachments[0])">下载</el-button>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="item-box-content" style="padding-bottom: 0;" v-if="bankformList.state === 3">
      <div class="title-font-style">
        <span>审核</span>
      </div>
      <el-form class="details-line-height" style="padding:20px 30px 0 30px">
        <el-row :gutter="20">
          <el-col :span="15">
            <el-form-item prop="state" label="审核结果：">
              <span style="color:#F56C6C"> {{states(bankformList.state)}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="15">
            <el-form-item label="备注：">
              {{bankformList.explain}}
            </el-form-item>
          </el-col>
        </el-row>

      </el-form>
    </div>

    <operation-log-and-flow :flowLabel="flowLabel" :typesel="typesel" :id="id"></operation-log-and-flow>

    <brand-dialog ref='brandDialogRef' :title="`查看`"></brand-dialog>
  </div>
</template>
<script>
import noticeApi from '@/api/workbench/notice'
import { downLoadFile, isSuccess } from '@/util/tool'
import { queryByOrderId } from '@/api/fiance/fianceManage'
import { formatData } from '@/util/filterCommon'
import operationLogAndFlow from '@/components/OperationLog/operationLogAndFlow'
import BrandDialog from '@/views/crm/components/supplier/dialog/brandDialog'
import checkApi from '@/api/workbench/check'

export default {
  components: {
    BrandDialog,
    'operation-log-and-flow': operationLogAndFlow
  },
  data () {
    return {

      flowLabel: '收款管理',
      typesel: 'financeAcceptanceBillRequestService',

      bankformList: {},
      params: {},
      id: ''

    }
  },
  filters: {
    billMoney (billMoney) {
      if (!billMoney) {
        return ''
      }
      return billMoney.toFixed(2)
    }
  },
  mounted () {
    this.id = this.$route.query.fabrId
    queryByOrderId(this.$route.query.fabrId)
      .then((res) => {
        if (res.data.code === 200) {
          this.bankformList = res.data.obj
        }
      })
      .catch((err) => {
        console.log(err)
      })
  },
  methods: {
    formatData,
    // 查看
    onSee (attachment) {
      if (attachment && attachment[0]) {
        const guid = attachment[0]
        checkApi.getPactFileUrl({ guid }).then(res => {
          if (isSuccess(res)) {
            const { filePath } = res.data.obj
            if (filePath) {
              const file = filePath.split('.')
              const fileType = file[file.length - 1]
              this.$refs.brandDialogRef.onBlackDialog([{
                filePath,
                fileExt: '.' + fileType
              }])
            }
          }
        })
      }
    },
    states (state) {
      if (state === 1) {
        return '收款审核'
      } else if (state === 2) {
        return '收款成功'
      } else if (state === 3) {
        return '收款审核不通过'
      }
    },
    // 获取公告详情
    queryNoticeDetail (snIdex) {
      let { snId } = this
      if (snIdex) {
        snId = snIdex
      }
      noticeApi
        .queryNoticeDetail({
          snId
        })
        .then((res) => {
          if (isSuccess(res)) {
            this.noticeDetailsObj = res.data.obj
            this.lastSnId = res.data.obj.lastSnId
            this.nextSnId = res.data.obj.nextSnId
          } else {
            this.$message({
              message: res.data.msg
            })
          }
        })
    },
    // 下载文件
    downloadFile (guid) {
      noticeApi
        .downloadNoticeFile({
          guid
        })
        .then((res) => {
          downLoadFile(res)
        })
    },
    previewFile () {
    },
    goCustomerDetail (id) {
      this.$router.push({ name: 'customer/details', query: { id } })
    }
  }
}
</script>
<style lang="scss" scoped>
  .pay {
    padding-top: 8px;
    font-weight: bold;
  }

  .look {
    color: blue;
    padding-left: 20px;
  }

  .down {
    margin: -7px;
  }
  ::v-deep .el-form-item--mini.el-form-item{
    margin-bottom: 20px;
  }
</style>
